<div class="container">
	<figure class="content-blocks--image" [class.content-blocks--image__centered]="params.size == 'centered'">
		<shop-picture [image]="imageFacade.loadSingleById(params.image) | async"></shop-picture>
		<figcaption *ngIf="params.caption">{{ params.caption }}</figcaption>
	</figure>
</div>
